import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import PushNotificationAdd from './add';
import PushNotificationDelete from './delete';
import axios from 'axios';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import dayjs from "dayjs";
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { useUser } from '../../AdminUsers/UserContext';

const ApplicationQueries = () => {
    const { checkPermission } = useUser();
    const [updateData, setUpdateData] = useState({});
    const [viewPopupStatus, setViewPopupStatus] = useState(false);    

      const [formValues, setFormValues] = useState({ 
        reply_message:''
      });
    
      const [errors, setErrors] = useState({
        reply_message:''
      });
    
      const handleInputChange = (field, value) => {
        setFormValues({ ...formValues, [field]: value });
      };    
    
    
      const validate = () => {
        const newErrors = {
        reply_message:''
        };  
        if (!formValues.reply_message.trim()) {
          newErrors.reply_message = 'Reply message cannot be empty';
        }     
        setErrors(newErrors);
        return Object.values(newErrors).every((error) => error === '');
      };  
    
      const clearInputValues = () => {
        setErrors({ 
         reply_message:''
        });
        setFormValues({
         reply_message:''
        });
      }; 
    const handleViewPopup = (type,data) => {
        setUpdateData(data);
        setViewPopupStatus(true);
    };


    const handleViewPopupClose = () => {
        setUpdateData({});
        clearInputValues();
        setViewPopupStatus(false);
    };

    const [applicationQueries, setApplicationQueries] = useState([]);
    function convertDBDate(dateStr) {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr);

    return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    }).format(date);
    }
    const fetchApplicationQueries = async () => {
        try {
          const response = await axios.post(
            `${baseUrl}/api/enquiry_form_list`,
            {search: ''},  
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {          
            setApplicationQueries(response.data.data);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };
    const sendReplyMessage = async (id) => {
        if (!validate()) {
          return;
        }
        try {
          const response = await axios.post(
            `${baseUrl}/api/send_mail_enquiry`,
            { 
              id: id,
              reply_message: formValues.reply_message 
            },  
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {
            showToast(response.data.message, 'success');
            fetchApplicationQueries();
            handleViewPopupClose();          
          } else {
            showToast(response.data.message, 'error');
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };
    
    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Name',
                field: 'name'
           },
           {
                label: 'Email ID',
                field: 'email_id'
            },
            {
                label: 'Mobile Number',
                field: 'mobile_number'
            },
             {
                label: 'Membership Number',
                field: 'member_no'
            },
           {
                label: 'Subject',
                field: 'subject'
            },
            // {
            //     label: 'Message',
            //     field: 'message',
            //     attributes: {
            //         style: { width: '2%', fontWeight: 'bold' },
            //     },
            // }, 
            {
                label: 'Date',
                field: 'created_on'
            },
            // {
            //     label: 'Action',
            //     field: 'action',
            //     attributes: {
            //         'aria-controls': 'DataTable',
            //         'aria-label': 'Action',
            //         style: { width: '1%', fontWeight: 'bold' },
            //     },
            // }
        ],
        rows:applicationQueries&&applicationQueries.map((data, index) => ({
            sno: index + 1,
            name:data.first_name || data.last_name? `${data.first_name || ""} ${data.last_name || ""}`
                  .trim()
                  .replace(/\s+/g, " ")
              : "N/A",
            created_on: convertDBDate(data.created_on) || "N/A",
            email_id: data.email_id || "N/A",
            mobile_number: data.mobile_number || "N/A",
            member_no: data.member_no || "N/A",
            subject: data.subject || "N/A", 
            // message: data.message || "N/A",
            // action: (
            //     <div>
            //       {/* <Tooltip text={data.send_status===1?"Send":"Re send"} id="send" /> */}
            //       <button 
            //         type="button" 
            //         onClick={(e) => { e.stopPropagation(); sendPushNotification(data.id); }}
            //         disabled={sendPushNotificationId === data.id}
            //         className="btn btn-sm btn-default edit_button_package" 
            //         title={data.send_status===1?"Send":"Re send"}
            //       >
            //         {sendPushNotificationId === data.id ? (
            //             <>
            //               <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            //               <span className="ms-2">Sending...</span>
            //             </>
            //           ) : (
            //             <>
            //              <i className="fa fa-paper-plane"></i> {data.send_status===1?"Send":"Resend"}
            //            </>
            //         )}                    
            //       </button>
            //     </div>
            // ),           
            clickEvent: () => handleViewPopup("Update",data),
        })),
    }
    // Check Admin User Permission
    const [checkUserLoading, setCheckUserLoading] = useState(false); 
    const fetchPermission = async () => {
      setCheckUserLoading(true);
      try {
        const hasPermission = await checkPermission("Application Queries", "view");
        if (!hasPermission) return;
      } catch (error) {
        console.error("Error fetching super specialty data:", error);
      }finally{
        setCheckUserLoading(false);
      }
    };
    useEffect(() => {
      fetchPermission();
    }, []);
    useEffect(() => {
      fetchApplicationQueries();
    }, []);

    return (
        <>
        <ToastMessage/> 
        {checkUserLoading? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          ) : (              
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Application Queries</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Application Queries</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[5, 10, 20]}
                                        entries={10}
                                        paging
                                        pagesAmount={5}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {updateData&&<div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Application Query</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    {/* <button onClick={()=> sendPushNotification(updateData.id)} disabled={sendPushNotificationId === updateData.id} className="saveand_proced_button btn btn-outline-info btn-block" type="button">
                                        {sendPushNotificationId === updateData.id ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span className="ms-2">Sending...</span>
                                          </>
                                        ) : (
                                           <>
                                            <i className="fa fa-paper-plane"></i> {updateData.send_status===1?"Send":"Resend"}
                                           </>
                                        )} 
                                    </button> */}
                                </div>
                                <span onClick={() =>handleViewPopupClose()} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Name</b> </small>
                                                            <p>{`${updateData.first_name || ""} ${updateData.last_name || ""}`}</p>
                                                        </div>
                                                         <div className="col-6">
                                                            <small className="text-muted"><b>Date</b> </small>
                                                            <p>{convertDBDate(updateData.created_on)}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Email ID</b> </small>
                                                            <p>{updateData.email_id}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Phone Number</b> </small>
                                                            <p>{updateData.mobile_number}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Membership Number</b> </small>
                                                            <p>{updateData.member_no}</p>
                                                        </div> 
                                                       <div className="col-12">
                                                            <small className="text-muted"><b>Subject</b> </small>
                                                            <p>{updateData.subject}</p>
                                                        </div>                                                      
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Message</b> </small>
                                                            <p>{updateData.message}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">                                                                                                         
                                                        <div className="col-12">
                                                          <small className="text-muted"><b>Reply Message</b> </small>
                                                          <div className="form-group pos_relative">
                                                            <textarea
                                                              rows={4}
                                                              type="text"
                                                              className={`form-control ${errors.reply_message ? "red_border" : ""}`}
                                                              value={formValues.reply_message}
                                                              onChange={(e) => handleInputChange("reply_message", e.target.value)}
                                                            />
                                                            {errors && (                          
                                                                <p className="text-danger pos_abos">{errors.reply_message}</p>                          
                                                            )}
                                                          </div>
                                                          <div>
                                                              <button onClick={()=>sendReplyMessage(updateData.id)} className="saveand_proced_button btn btn-outline-info btn-block" type="button"><i className="fa fa-paper-plane"></i> Reply </button>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>)}
        </>

    );

}
export default ApplicationQueries
